import React, { useState } from 'react';
import { IconButton, Portal, Button } from '@mui/material';
import { Close, ErrorOutline } from '@mui/icons-material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { PropTypes } from 'prop-types';
import moment from 'moment';

import '../common.scss';
import './VerticalPanel.scss';

function Alert({
  alert, dismissAlert, pulseAlert, clearPulseAlert,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  let isExpandable = false;
  let shrunkText = alert.text;
  if (alert.text.length > 50) {
    isExpandable = true;
    shrunkText = `${alert.text.substring(0, 50)}...`;
  }

  const [displayText, setDisplayText] = useState(shrunkText);
  const [alertStyle, setAlertStyle] = useState(
    isExpandable ? 'expandable' : '',
  );
  if (pulseAlert) {
    setTimeout(() => clearPulseAlert(), 1000);
  }

  return (
    <div className={`alert ${pulseAlert ? 'pulse-warn' : ''}`}>
      <div className={`alert-wrapper ${alertStyle}`}>
        <ErrorOutline htmlColor="#F44336" />
        <div className="alert-content">
          <div className="alert-body">
            {displayText}
            {isExpandable ? (
              <div style={{ width: '100%', paddingTop: '10px' }}>
                <Button
                  onClick={() => {
                    setDisplayText(isExpanded ? shrunkText : alert.text);
                    setAlertStyle(isExpanded ? 'expandable' : 'expanded');
                    setIsExpanded(!isExpanded);
                  }}
                  startIcon={
                    isExpanded ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <ArrowForwardIosIcon />
                    )
                  }
                >
                  {isExpanded ? 'Collapse' : 'Expand'}
                </Button>
              </div>
            ) : (
              ''
            )}
          </div>

          <div className="alert-details">
            <div className="timestamp">
              <span className="date">
                {moment(alert.timestamp).format('MMM D')}
              </span>
              <span>{moment(alert.timestamp).format('h:mm:ss A')}</span>
            </div>
            <Button onClick={() => dismissAlert(alert.id)}>Dismiss</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

Alert.propTypes = {
  alert: PropTypes.object.isRequired,
  dismissAlert: PropTypes.func.isRequired,
  pulseAlert: PropTypes.string.isRequired,
  clearPulseAlert: PropTypes.func.isRequired,
};

export default function AlertsPanel({
  container,
  close,
  alerts,
  dismissAlert,
  height,
  clearAll,
  pulseAlertId,
  clearPulseAlertId,
}) {
  const headerHeight = 65;
  return (
    <Portal container={container.current}>
      <div className="alerts vertical-panel">
        <div className="header">
          <h3>Alerts</h3>
          <Button className="clear-all" onClick={clearAll}>
            Clear all
          </Button>
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </div>

        <div
          className="content"
          style={{ maxHeight: height ? `${height - headerHeight}px` : '100%' }}
        >
          {alerts.map((alert) => (
            <Alert
              key={`alert-${alert.id}`}
              alert={alert}
              dismissAlert={dismissAlert}
              pulseAlert={pulseAlertId === alert.id}
              clearPulseAlert={clearPulseAlertId}
            />
          ))}
        </div>
      </div>
    </Portal>
  );
}

AlertsPanel.propTypes = {
  container: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  alerts: PropTypes.arrayOf(PropTypes.object),
  dismissAlert: PropTypes.func.isRequired,
  height: PropTypes.number,
  clearAll: PropTypes.func.isRequired,
  pulseAlertId: PropTypes.string,
  clearPulseAlertId: PropTypes.func,
};

AlertsPanel.defaultProps = {
  alerts: [],
  height: 0,
  pulseAlertId: null,
  clearPulseAlertId: null,
};
